module.exports = __webpack_public_path__ + "static/media/boothBg.b2397537.jpg";